// extracted by mini-css-extract-plugin
export default {"uiTpaColoPicker":"UKyaAS","description":"OINeio","productOptionsColorContainer":"sjaM8t","actionable":"s_PrLG","colorSamplerGroup":"eP4wAY"};